import React from 'react';
import InputField from '../Forms/InputField';
import NewDropdown from '../Forms/NewDropdown';

export default function ProfileDetails({ locationFields, setLocationFields, onCountryChange }) {

  const handleChange = (index, newValue, fieldName) => {
    // If it's the country field and onCountryChange is provided, use it
    if (fieldName === 'country' && onCountryChange) {
      onCountryChange(newValue);
    } else {
      // Otherwise use default behavior
      setLocationFields(prevFields =>
        prevFields.map((field, i) =>
          i === index ? { ...field, value: newValue } : field
        )
      );
    }
  };

  return (
    <section className="flex flex-col px-5  pb-6 bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
      <div className="flex flex-wrap gap-3 ">
        {locationFields.map((field, index) => (
          field.type === 'select' ? (
            field.data && field.data.length > 0 ? (
              // Show dropdown if data is available
              <div key={index} className="flex-1 min-w-[240px]">
                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">{field.label}</label>
                <div className="mt-1">
                  <NewDropdown
                    placeholder={field.placeholder}
                    dataList={field.data}
                    value={field.value}
                    onChange={(payload) => handleChange(index, payload.value, field.name)}
                    disabled={field.disabled}
                  />
                </div>
              </div>
            ) : (
              // Show text input if no data available (for countries without predefined states)
              <InputField
                key={index}
                label={field.label}
                placeholder={field.placeholder}
                value={field.value}
                onChange={e => handleChange(index, e.target.value, field.name)}
                disabled={field.disabled}
              />
            )
          ) : (
            <InputField
              key={index}
              label={field.label}
              placeholder={field.placeholder}
              value={field.value}
              onChange={e => handleChange(index, e.target.value, field.name)}
              disabled={field.disabled}
            />
          )
        ))}
      </div>
    </section>
  );
}